import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useServiceLinesStyles = makeStyles((theme: Theme) =>
  createStyles({
    createButton: {
      marginBottom: theme.spacing(2.5),
    },
    updateButton: {
      margin: theme.spacing(0.2),
      marginLeft: theme.spacing(0.4),
      height: '3rem',
    },
    deleteButton: {
      margin: theme.spacing(0.2),
      height: '3rem',
    },
  })
);

export default useServiceLinesStyles;
